import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SponsorshipStatusResponse} from '../Modules/education-info/models/SponsorshipStatusResponse';
import {BankDetailsResponse} from '../Modules/applicant-basic-info/models/BankDetailsResponse'
import {ApplicantBankInfo} from '../Modules/applicant-basic-info/models/ApplicantBankInfo';
import {BankList} from '../Modules/applicant-basic-info/models/BankList';
import {ApplicationSettingResponse} from '../../../shared/ApplicationSetting-response';
import { SharedHeadersService } from 'src/app/shared/shared-headers.service';

@Injectable({
  providedIn: 'root'
})
export class BankDetailsService {


  private apiBankDetailsUrl = environment.application_base_url + 'requestBankDetails/getBankDetails/';
  private applicantBankDetailsUrl = environment.application_base_url + 'requestBankDetails/applicantBankDetails/';
  private bankListUrl = environment.application_base_url +'requestBankDetails/bankLists/';
  application_config_url = environment.application_base_url


  constructor(private http: HttpClient,private shared_headers_service: SharedHeadersService) { }


  public requestBankDetails(accountNumber: string, bankCode: string): Observable<BankDetailsResponse> {
    const params = new HttpParams()
      .set('accountNumber', accountNumber)
      .set('bankCode', bankCode);
    return this.http.get<BankDetailsResponse>(this.apiBankDetailsUrl, { params, headers: this.shared_headers_service.default_headers()});
  }


  postBankDetails(requestBody: any) {
    return this.http.post(this.applicantBankDetailsUrl, requestBody, {headers:  this.shared_headers_service.default_headers()});
  }

  getApplicantBAnkDetails(indexno: string, appYear: string): Observable<ApplicantBankInfo>{
    const params = new HttpParams()
      .set('indexno', indexno)
      .set('appYear', appYear);
    return  this.http.get<ApplicantBankInfo>(this.applicantBankDetailsUrl, {params,  headers: this.shared_headers_service.default_headers()});
  }

  getAllBanks(): Observable<BankList>{
    return  this.http.get<BankList>(this.bankListUrl, { headers: this.shared_headers_service.default_headers()});
  }
  public getApplicationSettings(): Observable<ApplicationSettingResponse[]> {
    return this.http.get<ApplicationSettingResponse[]>(`${this.application_config_url}application_settings/olams-application_settings/`, {headers: this.shared_headers_service.default_headers()});
  }
}

